import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'codemirror/mode/javascript/javascript';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
if (environment.production) {
  enableProdMode();
}

if (environment.production) {
  // console.log = function (): void {};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
